<div class="rd-widget rd-widget-no-height-restriction widgetNoTopBorder">
  <table class="widget-small cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody *ngIf="editMode">
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'localAuthorityMunicipality'" [align]="'left'"></widget-label></td>
        <td colspan="8">
          <input type="text"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.localAuthorityMunicipality= $event;"
          id="localAuthorityMunicipality" [(ngModel)]="widgetData.localAuthorityMunicipality" class="widget-input-text widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'zoningPlanName'" [align]="'left'"></widget-label></td>
        <td colspan="8">
          <input type="text" hashtag [widget]="this" 
           [selectedTag]="hashTag" [elType]="'text'" [page]="page"  [editMode]="editMode" (setNewValue)="widgetData.zoningPlanName = $event;"
           id="zoningPlanName" [(ngModel)]="widgetData.zoningPlanName" class="widget-input-text widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'dateZoningApplication'" [align]="'left'"></widget-label></td>
        <td colspan="8">
          <input type="text"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.dateZoningApplication= $event;"
          id="dateZoningApplication" [(ngModel)]="widgetData.dateZoningApplication" class="widget-input-text widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'designetedUseClass'" [align]="'left'"></widget-label></td>
        <td colspan="8">
          <kendo-dropdownlist [data]="reflists['ref_use_class_items']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.designetedUseClass"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'authorisedUses'" [align]="'left'"></widget-label></td>
        <td colspan="8">
          <input type="text"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.authorisedUses= $event;"
          id="authorisedUses" [(ngModel)]="widgetData.authorisedUses" class="widget-input-text widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'permittedCoverageRatio'" [align]="'left'"></widget-label></td>
        <td colspan="8">
          <input type="text"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.permittedCoverageRatio= $event;"
          id="permittedCoverageRatio" [(ngModel)]="widgetData.permittedCoverageRatio" class="widget-input-text widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'permittedPlotRatio'" [align]="'left'"></widget-label></td>
        <td colspan="8">
          <input type="text"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.permittedPlotRatio= $event;"
          id="permittedPlotRatio" [(ngModel)]="widgetData.permittedPlotRatio" class="widget-input-text widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'cubicIndex'" [align]="'left'"></widget-label></td>
        <td colspan="8">
          <input type="text"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.cubicIndex= $event;"
          id="cubicIndex" [(ngModel)]="widgetData.cubicIndex" class="widget-input-text widget-h1 gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
    </tbody>

    <tbody *ngIf="!editMode" class="viewModeTbody">
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'localAuthorityMunicipality'" [align]="'left'"></widget-label></td>
        <td colspan="8"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{ widgetData.localAuthorityMunicipality}}</label></widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'zoningPlanName'" [align]="'left'"></widget-label></td>
        <td colspan="8"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{ widgetData.zoningPlanName}}</label></widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'dateZoningApplication'" [align]="'left'"></widget-label></td>
        <td colspan="8"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.dateZoningApplication}}</label></widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'designetedUseClass'" [align]="'left'"></widget-label></td>
        <td colspan="8"><widget-value [align]="'right'">{{( widgetData.designetedUseClass | rdReflist: reflists['ref_use_class_items'])}}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'authorisedUses'" [align]="'left'"></widget-label></td>
        <td colspan="8"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.authorisedUses}}</label></widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'permittedCoverageRatio'" [align]="'left'"></widget-label></td>
        <td *ngIf="(widgetData.permittedCoverageRatio || 0) == 0" colspan="8"><widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value></td>
        <td *ngIf="(widgetData.permittedCoverageRatio || 0) != 0" colspan="8"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{ widgetData.permittedCoverageRatio}}</label></widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'permittedPlotRatio'" [align]="'left'"></widget-label></td>
        <td *ngIf="(widgetData.permittedPlotRatio || 0) == 0" colspan="8"><widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value></td>
        <td *ngIf="(widgetData.permittedPlotRatio || 0) != 0" colspan="8"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{ widgetData.permittedPlotRatio }}</label></widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'cubicIndex'" [align]="'left'"></widget-label></td>
        <td colspan="8"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.cubicIndex}}</label></widget-value></td>
      </tr>
    </tbody>
  </table>
</div>
